import type { JSX } from 'react';

import { SpriteIcon } from '../sprite-icon';
import type { SVGProps } from '../types';

const SquareIcon = (props: SVGProps): JSX.Element => {
  return <SpriteIcon spriteId="checkbox-uncheck" {...props} />;
};

export { SquareIcon };
